import React, { useReducer, useEffect } from "react";
import axios from "axios";
import ConfigContext from "./ConfigContext";
import ConfigReducer from "./ConfigReducer";

import {
  CONFIG_LOADING,
  CONFIG_LOADED,
  CONFIG_LOAD_ERROR,
  RESET_CONFIG,
  FEEDBACK_LOADED,
  FEEDBACK_LOADING,
  FEEDBACK_LOAD_ERROR,
} from "../types";
import { env } from "../../env";

const API_HOST = env.REACT_APP_HMW_API_HOST_NAME;
// const API_HOST = "";
const ConfigState = (props) => {
  const configState = window.localStorage.getItem("config");
  const initialState = {
    generalConfig: localStorage.getItem("config")
      ? JSON.parse(configState).generalConfig
      : [],
    patronConfig: localStorage.getItem("config")
      ? JSON.parse(configState).patronConfig
      : [],
    patronMessageConfig: localStorage.getItem("config")
      ? JSON.parse(configState).patronMessageConfig
      : [],
    sponserMessageConfig: localStorage.getItem("config")
      ? JSON.parse(configState).sponserMessageConfig
      : [],
    validationRules: localStorage.getItem("config")
      ? JSON.parse(configState).validationRules
      : [],
    loading: false,
    loaded: false,
    error: null,
  };
  const [state, dispatch] = useReducer(ConfigReducer, initialState);

  useEffect(() => {
    if (state.loaded === true) {
      localStorage.setItem("config", JSON.stringify(state));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.loaded]);

  //Reset Context State
  const resetConfigState = () => {
    dispatch({
      type: RESET_CONFIG,
      payload: { ...initialState },
    });
  };

  //Load Config
  const loadConfig = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    // if(formData){
    //     formData.action="USER_MANAGEMENT";
    //     formData.function="login";
    //     formData.version="1";

    // }
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: CONFIG_LOADING,
          payload: { loading: true },
        });
        let res1 = await axios.get(
          `${API_HOST}/configParameters.json`,
          {},
          config
        );
        console.log("Config ", res1.data);
        const generalConfig = res1.data;
        // dispatch({
        //   type: CONFIG_LOADED,
        //   payload: { generalConfig: res.data, loaded: true },
        // });
        // loadUserCards({},token);
        let res2 = await axios.get(
          `${API_HOST}/messageResources.json`,
          {},
          config
        );
        const patronConfig = res2.data;
        // dispatch({
        //   type: CONFIG_LOADED,
        //   payload: { generalConfig, patronConfig, loaded: true },
        // });
        let res4 = await axios.get(
          `${API_HOST}/patronMessageResources.json`,
          {},
          config
        );
        const patronMessageConfig = res4.data;
        let res5 = await axios.get(
          `${API_HOST}/sponserMessageResources.json`,
          {},
          config
        );
        const sponserMessageConfig = res5.data;
        let res3 = await axios.get(
          `${API_HOST}/validationRules.json`,
          {},
          config
        );
        const validationRules = res3.data;
        dispatch({
          type: CONFIG_LOADED,
          payload: {
            generalConfig,
            patronConfig,
            patronMessageConfig,
            sponserMessageConfig,
            validationRules,
            loaded: true,
          },
        });
        resolve(res3.data);
      } catch (err) {
        console.log("Error in Config", JSON.stringify(err));
        console.log("Error Msg in Config", err.message);
        // console.log("Error Code in Config", err.response.status);
        dispatch({
          type: CONFIG_LOAD_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const submitFeedback = (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "FEEDBACK_FORM";
      formData.function = "submit";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: FEEDBACK_LOADING,
          payload: { loading: true },
        });
        let res = await axios.post(
          `${API_HOST}/feedback/save`,
          formData,
          config
        );
        console.log("Config ", res.data);
        dispatch({
          type: FEEDBACK_LOADED,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: FEEDBACK_LOAD_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  // const getConfigValue = (module, type, key) => {
  //   // let config = null;
  //   let configItem = {};

  //   // if(module ==='generalConfig'){
  //   //     config = state[module];
  //   // }else if(module ==='patronConfig'){
  //   //     config = state[module];
  //   // }
  //   if (state.generalConfig.length > 0) {
  //     configItem = state[module].filter(
  //       (item) => item.type === type && item.msgName === key
  //     );
  //     console.log(`Fetched Config for ${key} `, JSON.stringify(configItem));
  //     return configItem[0].msgValue;
  //   }
  //   console.log(`Fetched Config for ${key} `, "Empty");
  //   return null;
  // };

  const getConfigValue = (module, config, group) => {
    // let config = null;
    let configItem = [];

    // if(module ==='generalConfig'){
    //     config = state[module];
    // }else if(module ==='patronConfig'){
    //     config = state[module];
    // }
    if (state.generalConfig.length > 0) {
      configItem = state[module].filter((item) => {
        // console.log("Config Item", item);
        // console.log(`item.configName:${item.configName} == config:${config}}
        //   && item.groupName: ${item.groupName} == group:${group}`);
        return item.configName === config && item.groupName === group;
      });
      console.log(`Fetched Config for ${config} `, JSON.stringify(configItem));
      return configItem[0].configValue;
    }
    console.log(`Fetched Config for ${config} `, "Empty");
    return null;
  };

  const getConfigValueByCode = (module, type, code) => {
    // let config = null;
    let configItem = {};
    console.log(`Fetched Config ] `, state[module]);
    // if(module ==='generalConfig'){
    //     config = state[module];
    // }else if(module ==='patronConfig'){
    //     config = state[module];
    // }
    if (state.patronConfig.length > 0) {
      configItem = state.patronConfig.filter((item) => {
        // console.log(
        //   "TYPEOF",
        //   typeof item.msgCode,
        //   typeof code,
        //   parseInt(item.msgCode) === code,
        //   item.msgCode == code
        // );
        return item.type === type && parseInt(item.msgCode) === code;
      });
      console.log(
        `Fetched Config for ${code} of type ${type} `,
        JSON.stringify(configItem)
      );
      return configItem.length > 0 ? configItem[0].msgValue : null;
    }
    console.log(`Fetched Config for ${code} `, "Empty");
    return null;
  };

  const getConfigValueByName = (module, type, name) => {
    let configItem = {};
    console.log(`Fetched Config ] `, state[module]);
    if (state.patronConfig.length > 0) {
      configItem = state.patronConfig.filter((item) => {
        // console.log(
        //   "TYPEOF",
        //   typeof item.type,
        //   typeof type,
        //   "Match",
        //   item.type === type
        // );
        return item.type === type && item.msgName === name;
      });
      console.log(
        `Fetched Config for ${name} of type ${type} `,
        JSON.stringify(configItem)
      );
      return configItem.length > 0 ? configItem[0].msgValue : null;
    }
    console.log(`Fetched Config for ${name} `, "Empty");
    return null;
  };

  const getConfigValueByNamePatron = (module, type, name) => {
    let configItem = {};
    console.log(`Fetched Config ] `, module, state[module]);
    if (state.patronMessageConfig.length > 0) {
      configItem = state.patronMessageConfig.filter((item) => {
        // console.log(
        //   "TYPEOF",
        //   typeof item.type,
        //   typeof type,
        //   "Match",
        //   item.type === type
        // );
        return item.type === type && item.msgName === name;
      });
      console.log(
        `Fetched Config for ${name} of type ${type} `,
        JSON.stringify(configItem)
      );
      return configItem.length > 0 ? configItem[0].msgValue : null;
    }
    console.log(`Fetched Config for ${name} `, "Empty");
    return null;
  };

  const getConfigValueByNameSponser = (module, type, name) => {
    let configItem = {};
    console.log(`Fetched Config ] `, module, state[module]);
    if (state.sponserMessageConfig.length > 0) {
      configItem = state.sponserMessageConfig.filter((item) => {
        // console.log(
        //   "TYPEOF",
        //   typeof item.type,
        //   typeof type,
        //   "Match",
        //   item.type === type
        // );
        return item.type === type && item.msgName === name;
      });
      console.log(
        `Fetched Config for ${name} of type ${type} `,
        JSON.stringify(configItem)
      );
      return configItem.length > 0 ? configItem[0].msgValue : null;
    }
    console.log(`Fetched Config for ${name} `, "Empty");
    return null;
  };

  const getValidationRules = (lookup) => {
    // let config = null;
    const rulesMap = state.validationRules.filter(
      (item) =>
        item.action === lookup.action &&
        item.function === lookup.function &&
        item.version === lookup.version
    );
    let selectedRule = [];
    if (rulesMap.length > 0 && rulesMap[0].applicationResourceValidations) {
      selectedRule = rulesMap[0].applicationResourceValidations.filter(
        (item) => {
          return item.screenName === lookup.screenName;
        }
      );
    }
    return selectedRule;
  };

  return (
    <ConfigContext.Provider
      value={{
        generalConfig: state.generalConfig,
        loaded: state.loaded,
        loading: state.loading,
        error: state.error,
        loadConfig,
        getConfigValue,
        getConfigValueByCode,
        getConfigValueByName,
        getConfigValueByNamePatron,
        getConfigValueByNameSponser,
        getValidationRules,
        resetConfigState,
        submitFeedback,
      }}
    >
      {props.children}
    </ConfigContext.Provider>
  );
};

export default ConfigState;
